import { LOGIN, REFRESH_TOKEN, RESET_TOKEN } from "../actionTypes";

const login = (
  accessToken,
  expiresIn,
  refreshExpiresIn,
  refreshToken,
  tokenType,
  sessionState,
  scope,
  customerRefId,
  tokenExpire,
  username,
  password
) => {
  return {
    type: LOGIN,
    accessToken,
    expiresIn,
    refreshExpiresIn,
    refreshToken,
    tokenType,
    sessionState,
    scope,
    customerRefId,
    tokenExpire,
    username,
    password
  };
};

const refreshToken = (value) => {
  return {
    type: REFRESH_TOKEN,
    refreshToken: value
  };
};

const resetToken = () => {
  return {
    type: RESET_TOKEN
  }
}

export { login, refreshToken, resetToken };